import { Table } from "antd";
import TableAntd from "components/elements/Table/Table";
import { useTranslation } from "react-i18next";

const EmployeeSalaryAbsenceDeductTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onChange = () => { },
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: <div className="text-table">{t('holiday.label.date')}</div>,
      dataIndex: "date",
      key: "date",
      align: "center",
    },
    {
      title: <div className="text-table">{t('expense.expense-detail.amount')}</div>,
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: <div className="text-table">{t('salary.bonus')}</div>,
      dataIndex: "bonus",
      key: "bonus",
    },
    {
      title: <div className="text-table">{t('salary.label.modified_by')}</div>,
      dataIndex: "modifiedBy",
      key: "modifiedBy",
    },
  ];

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={dataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default EmployeeSalaryAbsenceDeductTable;
